import React from "react";

function programExcelCell(options, column, gridCell) {
  if (gridCell.value) {
    options.value = (gridCell.data[column.dataField + "_code"] || "")
      + "  "
      + (gridCell.data[column.dataField + "_name"] || "");
  }
}

function programCell(config, columnSpec) {
  let prefix = columnSpec.dataField;
  let codeField = prefix + "_code";
  let nameField = prefix + "_name";
  config.dataType = "string";
  config.calculateCellValue = (row) => {
    if (row[codeField] != null) {
      return (row[codeField] || "") + " | " + (row[nameField] || "");
    } else {
      return row[nameField] || "";
    }
  }
}

function programGroupingCell(config, columnSpec) {
  let prefix = columnSpec.dataField;
  let codeField = prefix + "_code";
  let nameField = prefix + "_name";
  config.dataType = "string";
  config.groupIndex = 0;
  config.calculateCellValue = (row) => {
    if (row[codeField] != null) {
      return (row[codeField] || "") + " | " + (row[nameField] || "");
    } else {
      return row[nameField] || "";
    }
  }
}

export {programCell,programGroupingCell, programExcelCell}
